import { FC } from 'react';
import Box from '@amzn/awsui-components-core/box';
import Header from '@amzn/awsui-components-core/header';
import Container from '@amzn/awsui-components-core/container';
import SpaceBetween from '@amzn/awsui-components-core/space-between';
import CampaignCardActions from 'src/components/atoms/CampaignCardActions';

export interface CampaignCardProps {
  title: string;
  description: string;
  createLabel: string;
  viewLabel: string;
  onCreateClick: () => void;
  onViewClick: () => void;
}

const CampaignCard: FC<CampaignCardProps> = ({
  title,
  description,
  createLabel,
  viewLabel,
  onCreateClick,
  onViewClick,
}) => {
  return (
    <Container header={<Header variant="h3">{title}</Header>}>
      <SpaceBetween size="m">
        <Box variant="p">{description}</Box>
        <CampaignCardActions
          createLabel={createLabel}
          viewLabel={viewLabel}
          onCreateClick={onCreateClick}
          onViewClick={onViewClick}
        />
      </SpaceBetween>
    </Container>
  );
};

export default CampaignCard;

